export default [
  'BOTArticles'
]

/*
Appears on:
/resources/all-about-tires
*/
